export default __webpack_public_path__ + "static/media/toud-d'eiffel.d36391f1.jpg";